<template>
    <div>
        <div role="tablist">
            <form method="POST">
                <b-card v-for="(tipoSeguimiento, indiceTipoSeg) in listaTipoSeguimientos"
                        :key="indiceTipoSeg"
                        no-body
                        class="border-0 mb-0"
                >
                    <b-card-header header-tag="header"
                                   class="p-0"
                                   :role="tipoSeguimiento"
                    >
                        <b-btn block
                               href="#"
                               v-b-toggle.tipoSeguimiento
                               variant="primary"
                        >
                            {{ indiceTipoSeg + 1 }}.{{ tipoSeguimiento.nombre }}
                        </b-btn>
                    </b-card-header>

                    <b-collapse id="mpa"
                                visible
                                role="tabpanel"
                    >
                        <div class="table-responsive">
                            <table class="table table-bordered table-sm table-striped table-hover">
                                <thead class="text-center table-active">
                                <tr>
                                    <th rowspan="2"></th>
                                    <th rowspan="2"
                                        class="align-middle"
                                        style="width: 20%"
                                        v-text="'ITEM'"
                                    />
                                    <th colspan="4"
                                        class="align-middle"
                                        style="text-align: center"
                                        v-text="'CUMPLE'"
                                    />
                                    <th rowspan="2"
                                        class="align-middle"
                                        style="width: 15%"
                                        v-text="'OBSERVACIONES'"
                                    />
                                    <th rowspan="2"
                                        class="align-middle"
                                        style="width: 15%"
                                        v-text="'OPORTUNIDAD DE MEJORA'"
                                    />
                                    <th rowspan="2"
                                        class="align-middle"
                                        v-text="'LEGISLACIÓN'"
                                    />
                                    <th rowspan="2"
                                        class="align-middle"
                                        v-text="'ÁREA'"
                                    />
                                    <th rowspan="2"
                                        style="width: 0px"
                                        class="align-middle"
                                    />
                                </tr>
                                <tr>
                                    <th>SI</th>
                                    <th>NM</th>
                                    <th>NO</th>
                                    <th>NA</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) in tipoSeguimiento.items"
                                    :key="index"
                                >
                                    <td class="font-weight-bold text-center">
                                        {{ indiceTipoSeg + 1 }}.{{ index + 1 }}
                                    </td>
                                    <td>{{ item.descripcion }}</td>
                                    <td class="text-center">
                                        <input type="radio"
                                               value="1"
                                               :name="'radio' + index + indiceTipoSeg"
                                               v-model="item.cumple"
                                               @change="changeValueCumple(1, index, indiceTipoSeg)"
                                        />
                                    </td>
                                    <td class="text-center">
                                        <input type="radio"
                                               value="2"
                                               :name="'radio' + index + indiceTipoSeg"
                                               v-model="item.cumple"
                                               @change="changeValueCumple(2, index, indiceTipoSeg)"
                                        />
                                    </td>
                                    <td class="text-center">
                                        <input type="radio"
                                               value="0"
                                               :name="'radio' + index + indiceTipoSeg"
                                               v-model="item.cumple"
                                               @change="changeValueCumple(0, index, indiceTipoSeg)"
                                        />
                                    </td>
                                    <td class="text-center">
                                        <input type="radio"
                                               value="9"
                                               :name="'radio' + index + indiceTipoSeg"
                                               v-model="item.cumple"
                                               @change="changeValueCumple(9, index, indiceTipoSeg)"
                                        />
                                    </td>
                                    <td style="width: 15%">
                                        <b-form-textarea rows="3"
                                                         cols="22"
                                                         name="observaciones"
                                                         v-model="item.observaciones"
                                                         v-if="item.cumple !== 1 && item.cumple !== 9"
                                        />
                                    </td>
                                    <td style="width: 15%">
                                        <b-form-textarea rows="3"
                                                         cols="22"
                                                         name="opciones_mejora"
                                                         v-model="item.opciones_mejora"
                                                         v-if="item.cumple == 2 || item.cumple == 0"
                                        />
                                    </td>
                                    <td style="width: 15%">
                                        <b-form-textarea rows="3"
                                                         cols="22"
                                                         name="legislacion"
                                                         v-model="item.legislacion"
                                        />
                                    </td>
                                    <td style="width: 15%">

                                        <input type="hidden" :value="getLocationName(item)">
                                        <b-form-textarea rows="3" cols="18" name="ubicacion" v-model="item.ubicacion" />

                                    </td>
                                    <td style="width: 0px">
                                        <b-button-group>
                                            <el-tooltip popper-class="py-1 px-2"
                                                        effect="dark"
                                                        placement="top-start"
                                                        content="Adjuntos"
                                            >
                                                <b-btn @click.stop="obtenerImagenes(item, indiceTipoSeg, index, $event.target)"
                                                    variant="secondary"
                                                    size="sm"
                                                >
                                                    <i class="fa fa-clipboard"></i>
                                                </b-btn>
                                            </el-tooltip>

                                            <el-tooltip popper-class="py-1 px-2"
                                                        class="mx-1"
                                                        effect="dark"
                                                        placement="top-start"
                                                        content="Guardar"
                                            >
                                                <b-btn
                                                    @click="showFormColumns(item, `${indiceTipoSeg + 1}.${index + 1}`, `${indiceTipoSeg + 1}.${tipoSeguimiento.nombre}`,tipoSeguimiento.id)"
                                                    variant="secondary"
                                                    size="sm"
                                                >
                                                    <i class="fa fa-eye"></i>
                                                </b-btn>
                                            </el-tooltip>

                                            <el-tooltip popper-class="py-1 px-2"
                                                        class="mx-1"
                                                        effect="dark"
                                                        placement="top-start"
                                                        content="Guardar"
                                            >
                                                <b-btn
                                                    @click="saveFindings(item)"
                                                    variant="primary"
                                                    size="sm"
                                                >
                                                    <i class="fa fa-save"></i>
                                                </b-btn>
                                            </el-tooltip>
                                        </b-button-group>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-collapse>
                </b-card>
            </form>

            <b-modal v-model="modal_imagenes"
                     title="Adjuntos"
                     hide-footer
            >

                <vue-dropzone id="dropzone"
                              ref="dropzone"
                              :options.sync="opciones"
                              v-on:vdropzone-file-added="enviarImagen"
                              :useCustomSlot=true
                              :multiple="false"

                >
                    <div class="dropzone-custom-content">
                        <h5 class="dropzone-custom-title">¡Arrastra y suelta aquí para subir un adjunto!</h5>
                        <div class="subtitle small">...o haz clic para seleccionar un archivo</div>
                    </div>
                </vue-dropzone>

                <b-table :items="arrImage"
                         :fields="columnas"
                         hover
                         small
                         striped
                         responsive="sm"
                         v-if="!!arrImage.length"
                >
                    <template v-slot:cell(mostrar_imagen)="row">
                        <b-form-checkbox :id="'checkbox-' + row.item.id"
                                         :name="'checkbox-' + row.item.id"
                                         v-model="row.item.mostrar_imagen"
                                         :value="1"
                                         :unchecked-value="0"
                                         :disabled="!esImagen(row.item) || contarActivos() >= 2 && !row.item.mostrar_imagen"
                                         @change="actualizarImagen(row.item.id)"
                        />
                    </template>

                    <template v-slot:cell(imagen)="row">
                        <img :src="'iconos/'+ icono(row.item)"
                             alt="icon"
                             height="15px"
                             class="mr-2"
                        >
                        {{ row.item.imagen }}<i class="header-icon el-icon-information"></i>
                    </template>

                    <template v-slot:cell(acciones)="row">
                        <a v-if="esImagen(row.item)"
                           v-b-tooltip.hover
                           title="Ver imágen"
                           size="sm"
                           @click="row.toggleDetails"
                           class="mx-1 text-primary"
                        >
                            <i class="fa fa-search"/>
                        </a>

                        <a v-else
                           v-b-tooltip.hover
                           size="sm"
                           class="mx-1 text-light"
                        >
                            <i class="fa fa-search"/>
                        </a>


                        <a v-b-tooltip.hover
                           title="Descargar"
                           size="sm"
                           class="mx-1 text-success"
                           @click="getRegistro(row.item)"
                        >
                            <i class="fa fa-download"/>
                        </a>

                        <a v-b-tooltip.hover
                           title="Eliminar"
                           size="sm"
                           class="mx-1 text-danger"
                           @click="_eliminarAdjunto(row.item)"
                        >
                            <i class="fa fa-trash"/>
                        </a>
                    </template>

                    <template #row-details="row">
                        <b-row>
                            <b-col class="text-center">
                                <b-img style="margin:auto; max-width: 300px; max-height: 300px"
                                       thumbnail
                                       fluid
                                       :src="'data:image/gif;base64,' + row.item.mini"
                                       alt="Logo"
                                       class="logo-empresa"
                                />
                            </b-col>
                        </b-row>
                    </template>
                </b-table>

            </b-modal>
        </div>
        <FindingForm></FindingForm>
    </div>

</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import vue2Dropzone from 'vue2-dropzone';
import findingForm from './findingForm.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
    name: 'hallazgos',
    props: ['planeacionCargar'],
    components: {
        vueDropzone: vue2Dropzone,
        FindingForm: findingForm,
    },
    data() {
        return {
            modal_imagenes: false,
            seleccionar: '',
            item_id: null,
            id_tipo_seguimiento: null,
            infoModal: {
                id: 'info-modal',
                titulo: '',
                content: '',
            },
            check: 0,
            Accion: '',
            opciones: {
                url: process.env.VUE_APP_API_URL + 'api/v1/empresas/imagen-hallazgos/crear',
                acceptedFiles: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpeg,.jpg,.png',
                maxFiles: 1,
                uploadMultiple: false,
                autoProcessQueue: false,
                headers: {
                    Authorization: '',
                    Accept: 'application/json',
                    contentType: false
                }
            },
            columnas: [
                {key: 'mostrar_imagen', label: '', thStyle: 'width: 30px'},
                {key: 'imagen', label: 'Nombre archivo'},
                {key: 'acciones', label: 'Acciones', thStyle: 'width: 80px'}
            ],
            iconos: [
                {
                    extensiones: ['doc', 'docx'],
                    icono: 'word.png'
                },
                {
                    extensiones: ['xls', 'xlsx'],
                    icono: 'excel.png'
                },
                {
                    extensiones: ['ppt', 'pptx'],
                    icono: 'power_point.png'
                },
                {
                    extensiones: ['pdf'],
                    icono: 'pdf.png'
                },
                {
                    extensiones: ['png', 'jpg', 'jpeg'],
                    icono: 'img.png'
                }
            ]
        };
    },
    created() {
        if (this.$route.params.id) {
            this.Accion = 'Actualizar';
        } else {
            this.Accion = 'Crear';
        }
    },
    methods: {
        async changeValueCumple(value, i, it) {
            this.listaTipoSeguimientos[it].items[i].cumple = value;
            this.$forceUpdate();
        },
        icono(adjunto) {
            const partes_nombre_imagen = adjunto.imagen.split('.');

            const extension = partes_nombre_imagen.pop();
            let icono = 'other.png';

            this.iconos.map(i => {
                const ext = i.extensiones.find(e => e === extension.toLowerCase());

                if (ext) {
                    icono = i.icono;
                }
            });

            return icono;
        },
        esImagen(adjunto) {
            const partes_nombre_imagen = adjunto.imagen.split('.');

            const extension = partes_nombre_imagen.pop();

            return ['png', 'jpg', 'jpeg'].includes(extension.toLowerCase());
        },
        contarActivos() {
            return this.arrImage.filter(a => a.mostrar_imagen).length;
        },
        async enviarImagen(file) {
            let formData = new FormData();

            formData.append('id_empresa', this.selectedListaChequeo.id_empresa);
            formData.append('id_lista_chequeo', this.selectedListaChequeo.id);
            formData.append('id_tipo_seguimiento', this.id_tipo_seguimiento);
            formData.append('id_item', this.item_id);
            formData.append('mostrar_imagen', 0);
            formData.append('imagen', file);

            await this.guardarImagen(formData).then(async () => {
                await this.obtenerImagenes();
            });

            this.$refs.dropzone.removeAllFiles(true);

        },
        async _eliminarAdjunto(adjunto) {
            await this.eliminarAdjunto(adjunto).then(async () => {
                await this.obtenerImagenes();
            });
        },
        async obtenerImagenes(item = null) {
            if (item) {
                this.item_id = item.id;
                this.id_tipo_seguimiento = item.id_tipo_seguimiento;

                const parametros = {
                    params: {
                        id_empresa: this.selectedListaChequeo.id_empresa,
                        id_lista_chequeo: this.selectedListaChequeo.id,
                        id_item: item.id
                    }
                };

                await this.listarImagenesHallazgo(parametros).then(() => {
                        this.modal_imagenes = true;
                    }
                );
            } else {
                const parametros = {
                    params: {
                        id_empresa: this.selectedListaChequeo.id_empresa,
                        id_lista_chequeo: this.selectedListaChequeo.id,
                        id_item: this.item_id
                    }
                };

                await this.listarImagenesHallazgo(parametros);
            }
        },
        /**
         * Obtener la ubicación.
         *
         * @author Fernando Claros
         */
        getLocationName(currentFinding) {

            let nameLocation = "No aplica";
            const location = this.searchLocationByIdIncludesYourChildrens(this.ubicaciones, this.selectedListaChequeo.id_ubicacion);
            if(location) nameLocation = location.label

            this.selectedListaChequeo.hallazgos.map(finding => {
                if (finding.id == currentFinding.id) finding.ubicacion = nameLocation
                return finding
            })

        },
        /**
         * Buscar la ubicación por su ID en todo el arbol.
         *
         * @param {*} dataLocations
         * @param {*} id
         * @author Fernando Claros
         */
        searchLocationByIdIncludesYourChildrens(dataLocations, id) {
            try {
                // Iterar sobre cada objeto dentro del array
                for (let i = 0; i < dataLocations.length; i++) {
                    const currentLocation = dataLocations[i];

                    // Verificar si el ID del objeto actual coincide con el ID buscado
                    if (currentLocation.id === id) return currentLocation;

                    // Si el objeto tiene hijos, buscar recursivamente en cada uno de ellos
                    if (currentLocation.children && currentLocation.children.length > 0) {
                        const result = this.searchLocationByIdIncludesYourChildrens(currentLocation.children, id);
                        if (result) return result;
                    }
                }

                // Si no se encuentra el objeto con el ID especificado, devolver null
                return null;
            } catch (e) {
                return null;
            }
        },
        showFormColumns(item,code, name, monitoring_type_id){
            console.log(item);
            this.showFindinForm({
                id: item.id,
                id_hallazgo: item.id_hallazgo,
                cumple: item.cumple,
                id_empresa: item.id_empresa,
                legislacion: item.legislacion,
                observaciones: item.observaciones,
                opciones_mejora: item.opciones_mejora,
                ubicacion: item.ubicacion,
                code,
                monitoring_type: name,
                monitoring_type_id
            });
        },
        ...mapActions('hallazgo', [
            'crearHallazgo',
            'verGraficas',
            'actualizarHallazgo',
            'guardarImagen',
            'actualizarImagen',
            'listarImagenesPlaneacion',
            'saveFindings',
            'showFindinForm'
        ]),
        ...mapActions('listaChequeo', [
            'listarHallazgos',
            'cambiarImagen',
            'getRegistro',
            'eliminarAdjunto',
            'listarImagenesHallazgo',
            'seleccionarImagen'
        ]),
        ...mapMutations('listaChequeo', ['setFiltroEmpresa', 'imagenUpdate', 'imagenCambiar', 'establecerHallazgosSelectedListaChequeo']),
        ...mapMutations('hallazgo', [
            'setAccion',
            'setFiltroGraficas',
            'setListaTipoSeguimientosCumple',
            'setfiltroRegistro',
            'cargaHallazgos',
            'asignarEmpresa'
        ]),
    },
    computed: {
        ...mapState('hallazgo', [
            'selectedHallazgo',
            'items',
            'accion',
            'error',
            'hallazgo',
            'bases_areas',
            'basesAreas',
            'id_empresa',
            'id_lista_chequeo',
            'hallazgoArr',
            'imagenSelecc',
            'findingModal',
        ]),
        ...mapState('listaChequeo', [
            'selectedListaChequeo',
            'tipoSeguimientos',
            'listaTipoSeguimientos',
            'arrImage',
            'ubicaciones'
        ])
    }
};
</script>

<style scoped >
.el-radio {
    margin-right: 10px;
}

.b-form-file-inner {
    height: 100%;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
}

.b-form-file-inner label {
    cursor: pointer;
}

.el-radio__inner {
    border: 1px solid black;
}

.el-radio__label {
    display: none;
}

.el-radio__input.is-checked + .el-radio__label {
    display: none;
}

.el-checkbox__inner {
    border: 1px solid #000 !important;
}

.dropzone-custom-content {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.dropzone-custom-title {
    margin-top: 40px;
    color: #097b83;
}

.subtitle {
    color: #314b5f;
}

</style>
